import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SuccessRadioSvg } from '../../../assets/icons/succes-radio.svg';
import { FormCaption, InformSpan, Button } from '../../common/components';
import { ROUTER_LINKS } from '../../common/consts/app-keys.const';
import { LogInIcon } from '../../common/components/icons/log-in-icon.component';

export const PasswordUpdated = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-center">
      <SuccessRadioSvg className="mx-auto mb-[20px]" aria-label="Success" />
      <FormCaption className="text-[24px]">
        {t('auth.passwordUpdatedTitle')}
      </FormCaption>
      <InformSpan>{t('auth.passwordUpdatedSubtitle')}</InformSpan>
      <Button onClick={() => navigate(ROUTER_LINKS.SIGNIN)} className="mt-[2px]">
        {t('auth.loginButton')}
        <LogInIcon className="h-[24px] w-[24px]" />
      </Button>
    </div>
  );
};
